import { useUI } from '../../context/AppContext.jsx';
import { useRobotConnection } from '../../hooks/useRobotConnection.js';

export default function FileListModal() {
  const { showFileListModal, setShowFileListModal } = useUI();
  const { robotFiles, downloadFromRobot, downloadFromRobotFTP, robotConnection } = useRobotConnection();

  const handleDownload = (filename) => {
    if (robotConnection.type === 'ftp') {
      downloadFromRobotFTP(filename);
    } else {
      downloadFromRobot(filename);
    }
  };

  if (!showFileListModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-bg-secondary rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Select Program from Robot</h2>
          <button
            onClick={() => setShowFileListModal(false)}
            className="text-text-secondary hover:text-text-primary text-2xl"
          >
            ×
          </button>
        </div>
        <div className="mb-4">
          {robotFiles.length === 0 ? (
            <div className="text-text-secondary text-center py-8">No .urp files found on robot</div>
          ) : (
            <ul className="space-y-2">
              {robotFiles.map((filename, index) => (
                <li
                  key={index}
                  onClick={() => handleDownload(filename)}
                  className="flex items-center gap-3 p-3 bg-bg-tertiary rounded hover:bg-bg-hover cursor-pointer transition-colors"
                >
                  <svg className="w-5 h-5 text-text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                  </svg>
                  <span className="text-text-primary">{filename}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="flex justify-end">
          <button
            onClick={() => setShowFileListModal(false)}
            className="bg-bg-tertiary text-text-primary px-4 py-2 rounded hover:bg-bg-hover transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

